import React, { useState, useEffect } from 'react';
import ImageDropzone from '../ImageDropzone';

const Req = () => <span style={{ color: '#e53e3e', marginLeft: '3px', fontWeight: '700' }}>*</span>;

const SliderModal = ({ editItem, modalImageUrl, setModalImageUrl, nextOrder, onSave, onClose }) => {
    const [orderVal, setOrderVal] = useState(editItem ? (editItem.order ?? 1) : (nextOrder || 1));

    useEffect(() => {
        setOrderVal(editItem ? (editItem.order ?? 1) : (nextOrder || 1));
    }, [editItem, nextOrder]);

    return (
        <div className="admin-modal-overlay" onClick={onClose}>
            <div className="admin-modal-card" onClick={(e) => e.stopPropagation()}>
                <div className="admin-modal-header">
                    <h3>{editItem ? 'Edit Hero Slide' : 'Add Hero Slide'}</h3>
                    <button className="close-btn" onClick={onClose}>✕</button>
                </div>
                <form onSubmit={onSave} className="admin-modal-body">
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                        <div>
                            <label className="admin-label">Badge Tag<Req /></label>
                            <input
                                type="text"
                                name="badge"
                                defaultValue={editItem?.badge || ''}
                                className="admin-input"
                                autoComplete="off"
                                required
                            />
                        </div>
                        <div>
                            <label className="admin-label">Display Order (#)<Req /></label>
                            <input
                                type="number"
                                name="order"
                                value={orderVal}
                                onChange={(e) => setOrderVal(e.target.value === '' ? '' : (parseInt(e.target.value) || 1))}
                                min="1"
                                className="admin-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="m-t15">
                        <label className="admin-label">Slide Main Title<Req /></label>
                        <input type="text" name="title" defaultValue={editItem?.title || ''} className="admin-input" required />
                    </div>
                    <div className="m-t15">
                        <label className="admin-label">Subtitle Description<Req /></label>
                        <textarea name="description" defaultValue={editItem?.description || ''} className="admin-textarea" rows="2" required />
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }} className="m-t15">
                        <div>
                            <label className="admin-label">Button 1 Label</label>
                            <input type="text" name="btn1Text" defaultValue={editItem?.btn1Text || 'Explore Products'} className="admin-input" />
                        </div>
                        <div>
                            <label className="admin-label">Button 1 Link</label>
                            <input type="text" name="btn1Link" defaultValue={editItem?.btn1Link || '/products'} className="admin-input" />
                        </div>
                    </div>

                    <div className="m-t15">
                        <ImageDropzone
                            label="Slide Background Image"
                            value={modalImageUrl}
                            onChange={setModalImageUrl}
                            fallback="/images/banner/6.jpg"
                        />
                    </div>

                    <div className="admin-modal-footer m-t20">
                        <button type="button" className="admin-btn admin-btn-secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="admin-btn admin-btn-primary">Save Slide</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SliderModal;
